
import _parseInt from 'lodash/parseInt';
import { select } from 'state/teamsnap/selectors';

const selectParticipantGroups = state => select(state, 'participantGroups');
const selectParticipantGroupById = (state, id) => selectParticipantGroups(state)[_parseInt(id)];

export { selectParticipantGroups, selectParticipantGroupById };
